<template>
  <div>
    <div class="modal" >
      <div class="modal-content">
        <span class="close" @click="showModal"><img src="@/assets/X.png" alt=""></span>
        <p style="width:100%;margin: 0 auto;" v-if="$route.params.lang =='zh'"><img style="width:100%;margin:0 auto" src="@/assets/jqqd.png" alt=""></p>
        <p style="width:100%;margin: 0 auto;" v-else><img style="width:100%;margin:0 auto" src="@/assets/jqqden.png" alt=""></p>
      </div>
    </div>
  </div>
</template>
 
<script>
export default {
  data() {
    return {
    };
  },
  methods:{
    showModal(){
      this.$emit('show',false)
    }
  }
};
</script>
 
<style scoped>
.modal {
  position: fixed; 
  z-index: 9999; 
  width: 100vw;
  height: 100vh;
  top:0;
  left: 0;
  overflow: auto; 
  background-color: rgba(0,0,0,0.58); 
}
.modal-content {
  background-color: #ffffff;
  margin: 20% auto;
  padding: 20px;
  /* border: 1px solid #888;  */
  width:5rem;
  /* height: 1000px; */
}
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  line-height: 30px;
  text-align: center;
  img{
    width: .3rem;
    height: .3rem;
  }
}
.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

@media (max-width: 640px) {
  .modal-content {
    margin: 50% auto;
    width:30rem;
  }
  .close {
    img{
      width: 3rem;
      height: 3rem;
    }
  }
}
</style>